import styled from "styled-components";
import { device } from "../breakpoints";

export const OurTeamSection = styled.section`
  padding: 120px 0;
  background: #fff
    url("https://tripmoneycmsimgak.mmtcdn.com/img/team_bg_4ae2dbf3f2.svg") top
    right no-repeat;
  margin-top: 16px;
  @media ${device.mobile} {
    padding: 40px 16px;
    background-size: cover;
  }
`;
export const OurTeamWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media ${device.mobile} {
    width: 100%;
  }
`;
export const OurTeamContent = styled.div`
  width: 720px;
  h2 {
    font-family: "Raleway";
    font-size: 48px;
    line-height: 64px;
    color: #000;
    font-weight: 400;
    margin-bottom: 24px;
  }
  p {
    font-family: "Open Sans";
    font-size: 22px;
    line-height: 30px;
    color: #4a4a4a;
  }
  h3 {
    font-family: "Raleway";
    font-size: 32px;
    line-height: 40px;
    color: #000;
    font-weight: 400;
    margin-top: 40px;
    margin-bottom: 12px;
  }
  @media ${device.mobile} {
    width: 100%;
    h2 {
      font-size: 32px;
      line-height: 34px;
    }
    p {
      font-size: 16px;
      line-height: 22px;
    }
    h3 {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;
